<template>
    <div class="sidebar-left">
        <div v-if="isLogedIn">
            <div class="sidebar-left--user-profile-tile">
                <v-list-item :to="user.username">
                    <v-list-item-avatar color="red" size="46">
                        <img v-if="user.avatar_url" :src="user.avatar_url" :alt="user.name">
                        <span class="white--text headline" v-else>{{user.name[0]}}</span>
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title>{{user.name}}</v-list-item-title>
                        <v-list-item-subtitle v-if="user.account_type">{{ user.account_type | role }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </div>
            <!-- <div class="sidebar-left--stories-tile mt-5">
                <widget-stories></widget-stories>
            </div> -->
            <div class="sidebar-left--suggestions-tile mt-5">
                <widget-suggestions></widget-suggestions>
            </div>
        </div>
        <div v-else>
            <account-login :noEntryAnim="true" :noHeaders="true"></account-login>
        </div>
        <footer class="sidebar-left--footer mt-8">
            <list-footer-nav></list-footer-nav>
            <p class="grey--text mt-2 caption">
                &copy; 2020 ARCLIFF
            </p>
        </footer>
    </div>
</template>
<script>
import accountLogin from "@/components/account/account-login.vue"
export default {
    components: {
        'account-login': accountLogin
    }
}
</script>